import { pathToUrl } from '../utils/router';
import { Course } from '../interfaces/course';
import { GetListResponse } from '../interfaces';
import { useFetch, usePost } from '../shared/reactQuery';
import { api } from '../shared/api';
import { handleFilterParams } from '../utils/global';

export const useGetCoursesList = () => useFetch<GetListResponse>('courses');

export const useGetCourse = (id: number) => useFetch<Course>(`courses/${id}`);
export const useGetCourseAttendances = (id: number) => useFetch<Course>(`courses/${id}/attendances`);

export const useCreateUser = (updater: (oldData: Course[], newData: Course) => Course[]) => {
  return usePost<Course[], Course>(pathToUrl('courses'), undefined, updater);
};

export const getCoursesList = async ({ start, count, filter }: { start?: number; count?: number; filter?: any }) => {
  const newParams = handleFilterParams({
    start,
    count,
    filter,
  });
  const { data: response }: any = await api.get(`courses?${newParams}`);
  return response;
};

export const useGetCourseAttendancesFilter = async (id: number,{filter }: { filter?: any }) => {
  const newParams = handleFilterParams({
    filter,
  });
  const { data: response }: any = await api.get(`courses/${id}/attendancesClassWorks?${newParams}`);
  return response;
};



export const createCourse = async (values: Course) => {
  const { data: response }: any = await api.post('courses', values);
  return response.data;
};

export const updateCourse= async ({ id, ...values }: { id: string; values: Course }) => {
  const { data: response }: any = await api.patch(`courses/${id}`, values);
  return response.data;
};

export const deleteCourse = async (id: number) => {
  const { data: response }: any = await api.delete(`courses/${id}`);
  return response.data;
};

export const enrollStudent = async (courseid: number,studentId: number) => {
  const { data: response }: any = await api.patch(`courses/${Number(courseid)}/enroll/${Number(studentId)}`,{});
    return response;
};

export const deleteStudentFromCourse = async (courseid: number,studentId: number) => {
  const { data: response }: any = await api.delete(`courses/${Number(courseid)}/dismiss/${Number(studentId)}`);
    return response;
};
